import { reactive } from "vue";
import Vuex from 'vuex'
import { client } from "@/main";
import _set from "lodash.set"
import sha256 from "crypto-js/sha256";
import soumettreOpportunite from "@/services/API/soumettreOpportunite.js";

const defaultState = reactive({
  opportunite: {
    entreprise:{
      raisonSociale:'',
      siren:null,
      nature:null,
      codeNaf:null,
      estGrandCompte: false,
      estAssujettiCee: false,
      siege: null,
      departement: null,
    },
    raisonMiseEnConcurrence: null,
    energie: null,
    compteursElectriques:[],
    dateMiseEnServiceCompteursElectrique: null,
    puissanceCompteursElectriqueSouhaitee: null,
    groupeActivite: null,
    codeNafSiege:null,
    compteursGaz:[],
    dateMiseEnServiceCompteursGaz: null,
    accesPce:false,
    accesRae:false,
    accordGrd:true,
    contact:{
      civilite:'M',
      nom:'',
      prenom:'',
      email:'',
      telephone:'',
      fonction: null,
      googleClientId: null
    },
    rgpd:null,
    mandatEnedisDonneLe: new Date().toISOString(),
    type: 'PROFESSIONNEL',
    typeCourtage:null,
    urlElectronLibre: null,
    estTraitee: null,
    consommationGazAnnuelleEstimee: '',
    estCommandePublique: false
  },
  entrepriseSirenOctaveId: null,
  departements: null,
  facturesDisponibles: true,
  factures: [],
  confirmationSecteur: null,
  indexEcranCourant: 0,
  erreurs:[],
  suggestionEntreprise: [],
  nomCheminCourant : "",
  nomCheminPrecedent: "",
  nomCheminsParcourus: [],
  isEntrepriseSuggeree: false,
  parametresUrlMarketing: null,
  parametresUrlParrainage: null
})

const state = defaultState;

const mutations = {
  SAVE_OPPORTUNITE(state, opportunite) {
    state.opportunite = opportunite
  },
  /**
   *
   * @param state
   * @param path [Array | String]
   * @param valeur
   * @constructor
   */
  UPDATE_OPPORTUNITE(state, {path, valeur}) {
    _set(state.opportunite, path, valeur);
  },
  ADD_COMPTEUR_ELECTRIQUE: function (state){
    state.opportunite.compteursElectriques.push({
      prm:''
    })
  },
  SET_COMPTEURS_ELECTRIQUE(state, compteurs) {
    state.opportunite.compteursElectriques.splice(0, state.opportunite.compteursElectriques.length);
    for (var compteur of compteurs) {
      state.opportunite.compteursElectriques.push(compteur);
    }
  },
  SET_COMPTEURS_GAZ(state, compteurs) {
    state.opportunite.compteursGaz.splice(0, state.opportunite.compteursGaz.length);
    for (var compteur of compteurs) {
      state.opportunite.compteursGaz.push(compteur);
    }
  },
  SET_COMPTEUR_ELECTRIQUE(state,{compteur,prm}){
    const indexCompteur = state.opportunite.compteursElectriques.indexOf(compteur)
    state.opportunite.compteursElectriques[indexCompteur].prm = prm.replace(/\s/g, '')
  },
  REMOVE_COMPTEUR_ELECTRIQUE: function (state,compteur){
    state.opportunite.compteursElectriques = state.opportunite.compteursElectriques.filter(x => x !== compteur);
  },
  RESET_COMPTEUR(state, typeEnergie) {
    const proprieteTypeEnergie = typeEnergie === "electricite" ? "compteursElectriques" : "compteursGaz";
    state.opportunite[proprieteTypeEnergie] = [];
  },
  ADD_COMPTEUR_GAZ: function (state){
    state.opportunite.compteursGaz.push({
      prm:''
    })
  },
  SET_COMPTEUR_GAZ(state,{compteur,prm}){
    const indexCompteur = state.opportunite.compteursGaz.indexOf(compteur)
    state.opportunite.compteursGaz[indexCompteur].prm = prm.replace(/\s/g, '')
  },
  REMOVE_COMPTEUR_GAZ: function (state,compteur){
    state.opportunite.compteursGaz = state.opportunite.compteursGaz.filter(x => x !== compteur);
  },
  SET_PUISSANCE_ELECTRIQUE: function (state, puissance) {
    state.opportunite.puissanceCompteursElectriqueSouhaitee = puissance;
  },
  SET_CONSOMMATION_GAZ: function (state, consommation) {
    state.opportunite.consommationGazAnnuelleEstimee = consommation;
  },
  SET_RGPD: function (state, value) {
    state.opportunite.rgpd = value;
  },
  SET_GOOGLE_CLIENT_ID: function (state, value) {
    state.opportunite.contact.googleClientId = value;
  },
  SET_TYPE: function (state, value) {
    state.opportunite.type = value;
  },
  SET_FACTURES_DISPONIBLES(state, value) {
    state.facturesDisponibles = value;
  },
  SET_FACTURES(state, value) {
    state.factures = value;
  },
  SET_ACCESS_RAE(state, value) {
    state.opportunite.accesRae = value;
  },
  SET_ACCESS_PCE(state, value) {
    state.opportunite.accesPce = value;
  },
  SET_ENTREPRISE_NATURE (state, value) {
    state.opportunite.entreprise.nature = value;
  },
  SET_ENTREPRISE_SUGGESTION (state, value) {
    state.suggestionEntreprise = value;
  },
  SET_ENTREPRISE_SIREN_OCTAVE_ID (state, value) {
    state.entrepriseSirenOctaveId = value;
  },
  SET_DEPARTEMENTS (state, value) {
    state.departements = value;
  },
  SET_IS_ENTREPRISE_SUGGEREE (state, value) {
    state.isEntrepriseSuggeree = value;
  },
  SET_PARAMETRES_URL_MARKETING (state, value) {
    state.parametresUrlMarketing = value;
  },
  SET_PARAMETRES_URL_PARRAINAGE (state, value) {
    state.parametresUrlParrainage = value;
  },
  SET_PUISSANCE_COMPTEUR_ELECTRIQUE (state, value) {
    state.opportunite.puissanceCompteursElectriqueSouhaitee = value;
  },
  SET_DATE_MISE_EN_SERVICE_COMPTEURS_ELECTRIQUE (state, value) {
    state.opportunite.dateMiseEnServiceCompteursElectrique = value;
  },
  SET_CONSOMMATION_GAZ_ANNUELLE_ESTIMEE (state, value) {
    state.opportunite.consommationGazAnnuelleEstimee = value;
  },
  SET_DATE_MISE_EN_SERVICE_COMPTEURS_GAZ (state, value) {
    state.opportunite.dateMiseEnServiceCompteursGaz = value;
  },
}

const getters = {
  opportunite: function (state){
    return state.opportunite
  },
  type: function (state){
    return state.opportunite.type
  },
  erreurs: function (state){
    return state.erreurs
  },
  confirmationSecteur: function (state) {
    return state.confirmationSecteur;
  },
  rgpd: function (state) {
    return state.opportunite.rgpd;
  },
  mandatEnedisDonneLe: function (state) {
    return state.opportunite.mandatEnedisDonneLe;
  },
  indexEcranCourant: function (state) {
    return state.indexEcranCourant;
  },
  googleClientId: function (state) {
    return state.opportunite.contact.googleClientId;
  },
  suggestions: () => {
    return state.suggestionEntreprise;
  },
  getContactSansGoogleClientId: (state) => {
    const { googleClientId, ...contact} = state.opportunite.contact;

    Object.keys(contact)
      .forEach((key) => {
        contact[key] = sha256(contact[key]).toString()
      });

    return contact;
  }
}

const actions = {
  getSuggestionEntreprise: (store, raisonSocialeEntreprise) => {
    client.get(`/api/v1/entreprise/suggestion/${raisonSocialeEntreprise}`).then(response => {
      store.commit('SET_ENTREPRISE_SUGGESTION', response.data);
    });
  },
  postSirenEnCoursFormulaire: () => {
    client.post(
      '/api/v1/entreprise/sauvegarder-siren',
      {"siren": state.opportunite.entreprise.siren}
    ).then((response) => {
      store.commit('SET_ENTREPRISE_SIREN_OCTAVE_ID', response?.data?.id ?? null)
    })
  },
  setPuissanceElectrique: function (store, puissance) {
    store.commit('SET_PUISSANCE_ELECTRIQUE', puissance)
  },
  setConsommationGaz: function (store, consommation) {
    store.commit('SET_CONSOMMATION_GAZ', consommation)
  },
  setGoogleClientId: function (store, value) {
    store.commit('SET_GOOGLE_CLIENT_ID', value)
  },
  setType: function (store, value) {
    store.commit('SET_TYPE', value)
  },
  setAccesRae: function (store, value) {
    store.commit('SET_ACCESS_RAE', value)
  },
  setAccesPce: function (store, value) {
    store.commit('SET_ACCESS_PCE', value)
  },
  setNatureEntreprise(store, value) {
    store.commit('SET_ENTREPRISE_NATURE', value)
  },
  getDepartements(store) {
    client.get("/api/v1/liste-departements").then(reponse => {
      let departements = reponse.data
      departements.unshift(
        {
          arrondissement: false,
          nom: null,
          numero: null,
        });
      store.commit("SET_DEPARTEMENTS", departements);
    });
  },
  setIsEntrepriseSuggeree(store, valeur) {
    store.commit("SET_IS_ENTREPRISE_SUGGEREE", valeur)
  },
  soumettreOpportunite(store) {
    return soumettreOpportunite(
      store.state.opportunite,
      store.state.facturesDisponibles ? store.state.factures : [],
      store.state.entrepriseSirenOctaveId,
      store.state.parametresUrlMarketing,
      store.state.parametresUrlParrainage
    ).then((opportuniteSoumise) => {
      store.commit("SAVE_OPPORTUNITE", opportuniteSoumise);

      return opportuniteSoumise
    });
  }
}

const store = new Vuex.Store({
  state:state,
  mutations:mutations,
  getters:getters,
  actions:actions,
  strict:false
})

export { store }
